// extracted by mini-css-extract-plugin
module.exports = {"InvalidCard":"styles_InvalidCard__3KjdJ","InvalidLogo":"styles_InvalidLogo__1suG8","InvalidContent":"styles_InvalidContent__W47Eu"};